import React from "react";
import { Navigate } from "react-router-dom";

// Only the super_admin can create / manage users.
export default function AdminRoute({ children }) {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  if (!user) return <Navigate to="/login" replace />;
  return user.role === "super_admin" ? children : <Navigate to="/management" replace />;
}
